import { useAccountSettingQuery } from "app/pages/sales-intelligence/query/queries/useAccountSettingQuery";
import { accountSettingKeyMap } from "app/pages/sales-intelligence/services/api/account-settings/types";

import { isAccountOptedInIndustryTaxonomy } from "../utils/accountIndustryTaxonomyOptIn";

/**
 * Read side of the industry-classification opt-in, separate from {@link useIndustryTaxonomyOptIn}
 * so a consumer that only reads does not also subscribe to the write mutation — the filter build context runs
 * this on every leads surface.
 *
 * Returns a settled boolean with no loading state: `onEnterSalesIntelligenceRoot` resolves the setting into
 * the cache before any SI page renders, so the first render already has the answer. The `useQuery` call
 * remains as the self-heal for the paths that skip the hook (apps-only) or where the read failed — both
 * settle to the new taxonomy unless the account explicitly opted out (`false`).
 */
export const useIsIndustryTaxonomyOptedIn = (): boolean => {
    const { data } = useAccountSettingQuery(accountSettingKeyMap.accountOptedInIndustryTaxonomy);

    return isAccountOptedInIndustryTaxonomy(data);
};
